import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';

import PC_Main from '../views/PC_Main.vue';
import PC_Interior from '../views/PC_Interior.vue';
import PC_About from '../views/PC_About.vue';
import PC_Contact from '../views/PC_Contact.vue';
import PC_Office from '../views/PC_Office.vue';

import Attere from '../views/office/Attere.vue';
import Donggwang from '../views/office/Donggwang.vue';
import Everhome from '../views/office/Everhome.vue';
import Fnc from '../views/office/Fnc.vue';
import Ilhwan from '../views/office/Ilhwan.vue';
import Imporm from '../views/office/Imporm.vue';
import Inno from '../views/office/Inno.vue';
import Pcn from '../views/office/Pcn.vue';
import Samu from '../views/office/Samu.vue';
import Seongui from '../views/office/Seongui.vue';
import Yeonseung from '../views/office/Yeonseung.vue';

const routes = [
	{
		path: '/',
		name: 'pcMain',
		component: PC_Main,
	},
	{
		path: '/pc/interior',
		name: 'pcInterior',
		component: PC_Interior,
	},
	{
		path: '/pc/about',
		name: 'pcAbout',
		component: PC_About,
	},
	{
		path: '/pc/contact',
		name: 'pcContact',
		component: PC_Contact,
	},
	{
		path: '/pc/project',
		name: 'pcProject',
		component: PC_Office,
	},

	{
		path: '/pc/project/attere',
		name: 'Attere',
		component: Attere,
	},
	{
		path: '/pc/project/donggwang',
		name: 'Donggwang',
		component: Donggwang,
	},
	{
		path: '/pc/project/everhome',
		name: 'Everhome',
		component: Everhome,
	},
	{
		path: '/pc/project/fnc',
		name: 'Fnc',
		component: Fnc,
	},
	{
		path: '/pc/project/ilhwan',
		name: 'Ilhwan',
		component: Ilhwan,
	},
	{
		path: '/pc/project/imporm',
		name: 'Imporm',
		component: Imporm,
	},
	{
		path: '/pc/project/inno',
		name: 'Inno',
		component: Inno,
	},
	{
		path: '/pc/project/pcn',
		name: 'Pcn',
		component: Pcn,
	},
	{
		path: '/pc/project/samu',
		name: 'Samu',
		component: Samu,
	},
	{
		path: '/pc/project/seongui',
		name: 'Seongui',
		component: Seongui,
	},
	{
		path: '/pc/project/yeonseung',
		name: 'Yeonseung',
		component: Yeonseung,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(async (to, from, next) => {
	const storeToken = store.getters.getToken;

	if (!to.matched.some(record => record.meta.unauthorized)) {
		return next();
	} else if (storeToken) {
		return next();
	}

	// alert('로그인 해주세요');
	return next('/LoginView');
});

export default router;
